import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { element } from 'protractor';
import { Config } from '../../config/config';
import { RestDataService } from '../../service/rest-data.service';
import { StaticDataService } from '../../service/static-data.service';

@Component({
  selector: '.story-version',
  templateUrl: './story-version.component.html',
  styleUrls: ['./story-version.component.scss']
})
export class StoryVersionComponent implements OnInit {

  @Input() currentVersion: any;

  @Input() versionHistory: any;
  @Input() indexClicked: number;

  @Output() public restoreClicked = new EventEmitter<any>();

  currentVersionElementsData: any[] = [];

  monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  leftSideVersion = null;
  rightSideVersion = null;

  leftSideVersionElements = [];
  rightSideVersionElements = [];

  leftSideVersionIndex: any = 0;
  rightSideVersionIndex: any = 0;

  constructor(private restService:RestDataService,private config:Config
  ) { }

  ngOnInit() {
    this.currentVersionElementsData = [];
    this.initializeLeftRightVersions();
  }

  initializeLeftRightVersions() {

    this.leftSideVersion = this.currentVersion;

    let elements = [];
    if (this.currentVersion.leadMedia !== null && this.currentVersion.leadMedia.elements.length != 0)
      elements = elements.concat(this.currentVersion.leadMedia.elements);

    if (this.currentVersion.leadMediaGif!==null && this.currentVersion.leadMediaGif.elements.length != 0)
      elements = elements.concat(this.currentVersion.leadMediaGif.elements);

    elements = elements.concat(this.currentVersion.elements);
    this.leftSideVersionElements = elements;
    this.leftSideVersionIndex = 'current';

    this.rightSideVersion = this.versionHistory.changes[this.indexClicked];
    this.rightSideVersionElements = this.versionHistory.elementChanges[this.versionHistory.changes.length - 1 - this.indexClicked];
    this.rightSideVersionIndex = this.indexClicked;
    this.getelementversion(this.versionHistory.changes.length - 1 - this.indexClicked,true);

  }
 


  // isCurrentVersionDifferent() {
  // console.log('this.currentVersion.lastModifiedDate ::: ', this.currentVersion.lastModifiedDate);
  // console.log('this.versionHistory.changes[0].lastModifiedDate ::: ', this.versionHistory.changes[0].lastModifiedDate);
  // let ans = (this.currentVersion.lastModifiedDate < this.versionHistory.changes[0].lastModifiedDate);
  // console.log('ans :: ', ans);

  // return true;
  // }

  /**
   * Get an Element Version
   * @param versionNumber 
   */
   getelementversion(versionNumber,right:boolean){
    if(this.versionHistory['elementChangesVersionId'][versionNumber]){
    this.restService.http_get(this.config.get('product').baseUrl
    + this.config.getEndPoint(this.config.get('views'), StaticDataService.story_page_id , StaticDataService.element_version_api)
    + '/' + this.versionHistory['elementChangesVersionId'][versionNumber])
    .subscribe(
      elementData => {
        // console.log('versions');
        if (elementData && elementData !== null) {
          if(right)
            this.rightSideVersionElements = elementData.elementChanges;
          else  
          this.leftSideVersionElements = elementData.elementChanges;
          }
        // console.log(data);
      },
      error => {
        console.log(error);
        // console.log('story version error');
      });
    } 
  }
  
  getUpadtedElementContent(ev) {
    if (ev.type === 'paragraph') {
      let obj = {
        id: ev.id,
        data: ev
      };
      this.currentVersionElementsData.push(obj);
    }
  }

  onLeftSideVersionDateChange(ev: any) {
    if (ev === 'current') {
      this.leftSideVersion = this.currentVersion;
      let elements = [];
      if (this.currentVersion.leadMedia!==null && this.currentVersion.leadMedia.elements.length != 0)
        elements = elements.concat(this.currentVersion.leadMedia.elements);

      if (this.currentVersion.leadMediaGif!==null && this.currentVersion.leadMediaGif.elements.length != 0)
        elements = elements.concat(this.currentVersion.leadMediaGif.elements);

      elements = elements.concat(this.currentVersion.elements);
      this.leftSideVersionElements = elements;
    } else {
      this.leftSideVersion = this.versionHistory.changes[ev];
      this.leftSideVersionElements = this.versionHistory.elementChanges[this.versionHistory.changes.length - 1 - ev];
      this.getelementversion(this.versionHistory.changes.length - 1 - ev,false);
    }
  }

  onRightSideVersionDateChange(ev: any) {
    this.rightSideVersion = this.versionHistory.changes[ev];
    this.rightSideVersionElements = this.versionHistory.elementChanges[this.versionHistory.changes.length - 1 - ev];
    this.getelementversion(this.versionHistory.changes.length - 1 - ev,true);
  }

  onRestoreClicked(storyVersionIndex) {
    this.restoreClicked.emit(storyVersionIndex);
  }

  disableRestoreButton(side) {
    if (side === 'left' && (this.leftSideVersionIndex == this.versionHistory.changes.length - 1 || this.leftSideVersion.metadata.killed || this.leftSideVersionIndex === 'current'))
      return true;
    else if (side === 'right' && (this.rightSideVersionIndex == this.versionHistory.changes.length - 1 || this.rightSideVersion.metadata.killed))
      return true;
    else
      return false;
  }

  getNewTypeVersionDate(datestring) {
    const dt = new Date(datestring.replace('+0000', 'Z'));
    return this.getVersionDate(Math.round(dt.getTime()));
  }

  getVersionDate(seconds) {
    if (seconds) {
      const date = new Date(seconds);
      const res =
        (this.monthNames[date.getMonth()])
        + ' '
        + (date.getDate())
        + ', '
        + (date.getFullYear())
        + ' ['
        + ((date.getHours() < 10) ? '0' + date.getHours() : date.getHours())
        + ':'
        + ((date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes()
          + ']'
        );
      return res;
    } else {
      return 'not present';
    }
  }

  getVersionModifiedByName(obj) {
    return (obj.metadata.status === 'CREATED') ? obj.createdBy :
      (obj.softPublished === true) ? obj.lastModifiedByUserName :
        (obj.metadata.status === 'PUBLISHED') ? obj.lastPublishedByUserName : obj.lastModifiedByUserName;
  }

  textDifference(str1, str2) {
    if ((str1 === null || str1 == '' || str1 == undefined) && (str2 === null || str2 == '' || str2 == undefined))
      return false;
    else if (str1 === null || str2 === null)
      return true;
    else
      return str1.trim() != str2.trim();
  }

  paragraphDifference(para1) {
    if (para1.type != 'paragraph')
      return false;

    if (this.rightSideVersionElements) {
      let para2 = this.rightSideVersionElements.find(e => e.id === para1.id);
      if (para2)
        return para1.paragraph.body.trim() != para2.paragraph.body.trim();
    }
    return true;
  }

  arrayDifference(arr1, arr2) {
    if(arr1 == null || arr2==null)
     return;
    return arr1.sort().join(',') != arr2.sort().join(',')
  }

  currentElementParagraphDifference(elemId) {

    let paraLeft = this.currentVersionElementsData.find(e => e.id === elemId);
    let paraRight = this.rightSideVersionElements.find(e => e.id === elemId);

    if ((paraRight == undefined && paraLeft == undefined) || (paraLeft !== undefined && paraLeft.data.type !== 'paragraph') || (paraRight !== undefined && paraRight.type !== 'paragraph')) {
      return false;
    }

    if (paraLeft && paraRight)
      return paraLeft.data.paragraph.body.trim() != paraRight.paragraph.body.trim();
    return true;

  }

}
